import type {ReactNode} from 'react'

export interface ContactInfoRowProps {
  children: ReactNode
  leading: ReactNode
  trailing: ReactNode
}

export const ContactInfoRow = (props: ContactInfoRowProps) => {
  const {children, leading, trailing} = props
  return (
    <div
      className={'group border-b border-outline-secondary py-spacing-24 first:border-t'}
      data-cy={'contact-info-row'}
    >
      <div className={'flex h-spacing-44 items-center gap-spacing-16'}>
        <span className={'shrink-0'}>
          {leading}
        </span>
        <span className={'min-w-0 truncate'}>
          {children}
        </span>
        <span className={'ml-auto hidden items-center group-hover:flex'}>
          {trailing}
        </span>
      </div>
    </div>
  )
}
